import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'secondsToHour',
})
export class SecondsToHourPipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}

  private translateHoursOnly(hours: number): string {
    return this.translateService.instant('General_Hours', { hours });
  }

  private translateMinutes(minutes: number): string {
    return this.translateService.instant('General_Minutes', { minutes });
  }

  public transform(value: number): string {
    const hour = Math.floor(value / 3600);

    const minute = Math.floor((value % 3600) / 60);
    return `${hour > 0 ? this.translateHoursOnly(hour) : ''} ${minute > 0 ? this.translateMinutes(minute) : ''}`;
  }
}
